import { Link } from 'react-router-dom';

export default function Areas() {
  const mainAreas = [
    { name: 'Watford', icon: 'ri-map-pin-fill' },
    { name: 'Rickmansworth', icon: 'ri-map-pin-fill', link: '/electrician-rickmansworth' }
  ];

  const surroundingAreas = [
    { name: 'Croxley Green', link: '/electrician-croxley-green' },
    { name: 'Chorleywood', link: '/electrician-in-chorleywood' },
    { name: 'Pinner', link: '/electrician-pinner' },
    { name: 'Northwood', link: '/electrician-in-moor-park-northwood' },
    { name: 'Bushey', link: '/electrician-bushey' },
    { name: 'Abbots Langley', link: '/electrician-abbots-langley' },
    { name: 'Harrow', link: '/electrician-harrow' },
    { name: 'Ruislip', link: '/electrician-ruislip' },
    { name: 'Stanmore', link: '/electrician-stanmore' },
    { name: 'Edgware', link: '/electrician-edgware' },
    { name: 'Mill Hill', link: '/electrician-mill-hill' },
    { name: 'Radlett', link: '/electrician-radlett' },
    { name: 'Borehamwood', link: '/electrician-borehamwood' },
    { name: 'Elstree', link: '/electrician-elstree' },
    { name: 'Potters Bar', link: '/electrician-potters-bar' },
    { name: 'South Oxhey', link: '/electrician-south-oxhey' }
  ];

  return (
    <section id="areas" className="py-16 sm:py-20 bg-gradient-to-b from-[#0D1F3C] to-[#0A1628] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3">
            Areas We <span className="text-[#FFD700]">Cover</span>
          </h2>
          <p className="text-gray-400 text-base sm:text-lg">
            Expert electrical services across Hertfordshire and surrounding areas
          </p>
        </div>

        {/* Main Service Areas */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12">
          {mainAreas.map((area, index) => {
            const content = (
              <div className="bg-gradient-to-br from-[#FFD700] to-[#FFC700] p-6 sm:p-8 rounded-2xl shadow-2xl hover:scale-105 transition-all duration-300">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#0A1628] rounded-full flex items-center justify-center shrink-0">
                    <i className={`${area.icon} text-[#FFD700] text-2xl sm:text-3xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-2xl sm:text-3xl font-bold text-[#0A1628]">{area.name}</h3>
                    <p className="text-[#0A1628]/80 font-medium text-sm sm:text-base">Primary Service Area</p>
                  </div>
                </div>
              </div>
            );

            return area.link ? (
              <Link key={index} to={area.link} className="cursor-pointer">
                {content}
              </Link>
            ) : (
              <div key={index}>
                {content}
              </div>
            );
          })}
        </div>

        {/* Surrounding Areas */}
        <div className="bg-white/5 backdrop-blur-sm border border-[#FFD700]/20 rounded-2xl p-5 sm:p-8">
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-5 sm:mb-6 text-center">
            <i className="ri-map-2-line text-[#FFD700] mr-2"></i>
            Surrounding Areas We Serve
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {surroundingAreas.map((area, index) => {
              const content = (
                <div className="bg-[#0A1628]/50 border border-[#FFD700]/30 rounded-lg px-3 py-2.5 text-center hover:bg-[#FFD700]/10 hover:border-[#FFD700] transition-all duration-300 group cursor-pointer">
                  <span className="text-gray-300 group-hover:text-[#FFD700] font-medium text-xs sm:text-sm">
                    {area.name}
                  </span>
                </div>
              );

              return area.link ? (
                <Link key={index} to={area.link}>
                  {content}
                </Link>
              ) : (
                <div key={index}>
                  {content}
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-10 sm:mt-12 text-center">
          <p className="text-gray-300 text-base sm:text-lg mb-5">
            Don't see your area? <span className="text-[#FFD700] font-semibold">Give us a call!</span>
          </p>
          <a
            href="tel:02031981818"
            className="inline-flex items-center gap-3 bg-[#FFD700] text-[#0A1628] px-7 py-3.5 rounded-full font-bold text-base sm:text-lg hover:bg-[#FFC700] transition-all duration-300 shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill text-lg sm:text-xl"></i>
            020 3198 1818
          </a>
        </div>
      </div>

      <div className="absolute top-10 right-0 w-48 h-48 bg-[#FFD700]/5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-10 left-0 w-64 h-64 bg-[#FFD700]/5 rounded-full blur-3xl pointer-events-none"></div>
    </section>
  );
}